import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalState {
  private _user: any = null;
  public user$ = new BehaviorSubject<any>(null);

  private _token: string = '';
  public token$ = new BehaviorSubject<string>('');

  private _pagador: string = '';
  public pagador$ = new BehaviorSubject<string>('');

  private _scrollY: number = 0;
  public scrollY$ = new BehaviorSubject<number>(0);

  private _allEds: Array<{ label: string; value: number; desde: Date }> = [];
  public allEds$ = new BehaviorSubject<
    Array<{ label: string; value: number; desde: Date }>
  >([]);

  private _isArcoprime: boolean = false;
  public isArcoprime$ = new BehaviorSubject<boolean>(false);

  private _pagadores: Array<{ id_pagador: string; label: string }> = [];
  public pagadores$ = new BehaviorSubject<
    Array<{ id_pagador: string; label: string }>
  >([]);

  // Subconjunto de pagadores con EDS activa (vigente). Solo lo usan las
  // pantallas de ingreso; los historiales usan `pagadores` (todos).
  private _pagadoresActivos: Array<{ id_pagador: string; label: string }> = [];
  public pagadoresActivos$ = new BehaviorSubject<
    Array<{ id_pagador: string; label: string }>
  >([]);

  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value ?? '';
    this.token$.next(this._token);
  }

  constructor() {}

  get user(): any {
    return this._user;
  }

  set user(value: any) {
    this._user = value ?? null;
    this.user$.next(this._user);
  }

  get pagador(): string {
    return this._pagador;
  }

  set pagador(value: string) {
    this._pagador = value ?? '';
    this.pagador$.next(this._pagador);
  }

  get allEds(): Array<{ label: string; value: number; desde: Date }> {
    return this._allEds;
  }

  set allEds(value: Array<{ label: string; value: number; desde: Date }>) {
    this._allEds = Array.isArray(value) ? value : [];
    this.allEds$.next(this._allEds);
  }

  get scrollY(): number {
    return this._scrollY;
  }

  set scrollY(value: number) {
    this._scrollY = value ?? 0;
    this.scrollY$.next(this._scrollY);
  }

  get isArcoprime(): boolean {
    return this._isArcoprime;
  }

  set isArcoprime(value: boolean) {
    this._isArcoprime = !!value;
    this.isArcoprime$.next(this._isArcoprime);
  }

  get pagadores(): Array<{ id_pagador: string; label: string }> {
    return this._pagadores;
  }

  set pagadores(value: Array<{ id_pagador: string; label: string }>) {
    this._pagadores = Array.isArray(value) ? value : [];
    this.pagadores$.next(this._pagadores);
  }

  get pagadoresActivos(): Array<{ id_pagador: string; label: string }> {
    return this._pagadoresActivos;
  }

  set pagadoresActivos(value: Array<{ id_pagador: string; label: string }>) {
    this._pagadoresActivos = Array.isArray(value) ? value : [];
    this.pagadoresActivos$.next(this._pagadoresActivos);
  }
}
